jQuery(document).ready(function(jQuery) {  
  /*################### Home Pages ######################*/

  /* Sticky Header */
  function sticky_section() {
    var header_h = jQuery('.nav-bar').height();
    jQuery(window).scroll(function(){
      var sticky = jQuery('.header-section'),
          scroll = jQuery(window).scrollTop();
      if (scroll >= 210){
        sticky.addClass('fixed');
        jQuery('body').addClass('fixed');
        jQuery('body').css('padding-top', header_h);
      }
      else {
        sticky.removeClass('fixed');
        jQuery('body').removeClass('fixed');
        jQuery('body').css('padding-top', '0');
      }
    });
  }
  sticky_section();
  jQuery(window).on('load resize orientationchange', sticky_section);

  /* Mobile Search bar */
  jQuery('.m-search-toggle, .m-search-c-toggle').click(function(){
    jQuery(".header-mobile-search").toggleClass('active');
    jQuery("#boost-pfs-search-box-1").focus();
  });

  /* Desktop Search bar */
  jQuery('.header-icons .btn-search, .header-search__popup-close').click(function(){
    jQuery(".header-search__popup").toggleClass('active');
    jQuery("#boost-pfs-search-box-0").focus();
  });

  /* Cart Drawer */
  setTimeout(function(){
    function cart_drawer() {
      var body_width = jQuery('body').width();
      var header_wrapper = jQuery('.main-header .wrapper').width();
      var temp_width = body_width - header_wrapper; 
      var temp_width_2 = temp_width / 2;
      jQuery(".cart__drawer").css('right', temp_width_2);    
    }
    cart_drawer();
    jQuery(window).on('load resize orientationchange', cart_drawer);
    
  }, 1500);
  
  jQuery('.announcement-slider').slick({
    arrows: false,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    vertical: false,
    adaptiveHeight: false,
    prevArrow:'<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
    nextArrow:'<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          dots: false,
        }
      },
      {
        breakpoint: 767,
        settings: {
          arrows: false,
          dots: false,
        }
      }
    ]
  });
  
  if (jQuery('body').hasClass("template-index")) {
  /* Slick Slider */
  jQuery('.js-banner-slider').slick({
    arrows: true,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    adaptiveHeight: true,
    prevArrow:'<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
    nextArrow:'<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          dots: true,
        }
      }
    ]
  });
  }
  
  jQuery('.js-logo-slider').slick({
    arrows: true,
    dots: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    prevArrow:'<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
    nextArrow:'<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

    /* Trustpilot custom */
   jQuery('.js-review-slider').slick({
    arrows: true,
    dots: false,
    slidesToShow: 5,
    slidesToScroll: 5,
    infinite: true,
    autoplay: true,     
    autoplaySpeed: 5000,
    prevArrow:'<button type="button" class="slick-prev"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="position: absolute; height: 100%; width: 100%; left: 0; top: 0;"><circle class="arrow-slider-circle" cx="12" cy="12" r="11.5" fill="none" stroke="#8C8C8C"></circle><path class="arrow-slider-shape" fill="#8C8C8C" d="M10.5088835 12l3.3080582-3.02451041c.2440777-.22315674.2440777-.5849653 0-.80812204-.2440776-.22315673-.6398058-.22315673-.8838834 0L9.18305826 11.595939c-.24407768.2231567-.24407768.5849653 0 .808122l3.75000004 3.4285714c.2440776.2231568.6398058.2231568.8838834 0 .2440777-.2231567.2440777-.5849653 0-.808122L10.5088835 12z"></path></svg></button>',
    nextArrow:'<button type="button" class="slick-next"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="position: absolute; height: 100%; width: 100%; left: 0; top: 0;"><circle class="arrow-slider-circle" cx="12" cy="12" r="11.5" fill="none" stroke="#8C8C8C"></circle><path class="arrow-slider-shape" fill="#8C8C8C" d="M10.5088835 12l3.3080582-3.02451041c.2440777-.22315674.2440777-.5849653 0-.80812204-.2440776-.22315673-.6398058-.22315673-.8838834 0L9.18305826 11.595939c-.24407768.2231567-.24407768.5849653 0 .808122l3.75000004 3.4285714c.2440776.2231568.6398058.2231568.8838834 0 .2440777-.2231567.2440777-.5849653 0-.808122L10.5088835 12z"></path></svg></button>',
    responsive: [
      {
        breakpoint: 1279,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 567,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  jQuery('.js-collection-slider').slick({
    arrows: true,
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    infinite: true,
    autoplaySpeed: 6000,
    prevArrow:'<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
    nextArrow:'<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
    responsive: [
      {
        breakpoint: 1365,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 1200, 
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,          
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,          
        }
      }
    ]
  });

  jQuery('.js-f-gallery-slider').slick({
    arrows: true,
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    infinite: true,
    autoplaySpeed: 6000,
    prevArrow:'<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
    nextArrow:'<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
    responsive: [
      {
        breakpoint: 1365,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 1200, 
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
  
  jQuery('.js-pro-slider').slick({
    arrows: true,
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    infinite: true,
    autoplaySpeed: 6000,
    prevArrow:'<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
    nextArrow:'<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
    responsive: [
      {
        breakpoint: 1365,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 1200, 
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  jQuery('.js-galley-slider').slick({
    arrows: true,
    dots: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: false,
    infinite: true,
    autoplaySpeed: 6000,
    prevArrow:'<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
    nextArrow:'<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  jQuery('.js-f-col-slider').slick({
    arrows: false,
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: false,
    infinite: true,
    autoplaySpeed: 6000,
    prevArrow:'<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
    nextArrow:'<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
    responsive: [
      {
        breakpoint: 1365,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 1200, 
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  jQuery('.js-sub-cat-slider').slick({
    arrows: true,
    dots: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: false,
    infinite: true,
    autoplaySpeed: 6000,
    prevArrow:'<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
    nextArrow:'<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
    responsive: [
      {
        breakpoint: 1365,
        settings: {
          slidesToShow: 5,
        }
      },
      {
        breakpoint: 1200, 
        settings: {
          slidesToShow: 5,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  if (jQuery('body').hasClass("template-product")) {
  /* Product Page */ 
  jQuery('.js-product-slider').slick({
    arrows: true,
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    autoplay: false,
    //centerMode: true,
    autoplaySpeed: 4000,
    prevArrow:'<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
    nextArrow:'<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        }
      }
    ]
  });

  jQuery(".sort-desc-link").click(function(){
    jQuery(".p-accordion-list .p-accordion-block:first-child").toggleClass('activeToggle');
    jQuery(".p-accordion-list .p-accordion-block:first-child .p-accordion-content ").show();
  });
   
  jQuery(".p-accordion-content").hide(); 
  jQuery(".p-accordion-title").click(function(){
    jQuery(this).toggleClass('active');
    if(jQuery(this).hasClass('active')){
      jQuery('.p-accordion-content').slideUp();
      jQuery('.p-accordion-title').not(this).removeClass('active');
      jQuery('.p-accordion-block').removeClass('activeToggle');
      jQuery(this).addClass('active');
      jQuery(this).next('.p-accordion-content').slideDown();
      jQuery(this).parent().addClass("activeToggle");
    } else {
      jQuery(this).removeClass('active');
      jQuery(this).next('.p-accordion-content').slideUp();
      jQuery(this).parent().removeClass("activeToggle"); 
    }
  });

  /* Frequently Bought Together APP Wrapper */
  function fbt_section() {
    var body_width = jQuery('body').width();
    var pro_wrapper = jQuery('#ProductSection .wrapper').width();
    var temp_width = body_width - pro_wrapper; 
    var temp_width_2 = temp_width / 2;
	jQuery(".cbb-frequently-bought-container").css('padding-left', temp_width_2);
    jQuery(".cbb-frequently-bought-container").css('padding-right', temp_width_2);
  }
  setTimeout(function() {
    fbt_section();
  }, 800);
  jQuery(window).on('load resize orientationchange', fbt_section);
  }

  /* Accordion */
  jQuery(".s-accordion-content").hide(); 
  jQuery(".s-accordion-title").click(function(){
    jQuery(this).toggleClass('active');
    if(jQuery(this).hasClass('active')){
      jQuery('.s-accordion-content').slideUp();
      jQuery('.s-accordion-title').not(this).removeClass('active');
      jQuery('.s-accordion-block').removeClass('activeToggle');
      jQuery(this).addClass('active');
      jQuery(this).next('.s-accordion-content').slideDown();
      jQuery(this).parent().addClass("activeToggle");
    } else {
      jQuery(this).removeClass('active');
      jQuery(this).next('.s-accordion-content').slideUp();
      jQuery(this).parent().removeClass("activeToggle"); 
    }
  });

  if (!jQuery('body').hasClass("template-index")) {
  /* Blog and Article */
  jQuery('.blog-reult').click(function(){
    jQuery(".blog-tag-filter").toggleClass('active');
  });

  $('[data-fancybox]').fancybox({
    buttons : [
      'close'
    ],
    wheel : false,
    transitionEffect: "slide",
    loop            : true,
    toolbar         : false,
    clickContent    : false
  });

  /* Same Height Blog Grid */
  function blog_section() {  
  jQuery(".blog-section .blog-item .blog-item-inner").each(function () {
    function e() {
      jQuery(".blog-section .blog-item .blog-item-inner").css("height", "auto");
      var e = -1;
      jQuery(".blog-section .blog-item .blog-item-inner").each(function () {
        var t = jQuery(this).outerHeight();
        e = t > e ? t : e
      }), jQuery(".blog-section .blog-item .blog-item-inner").css("height", e)
    }
    jQuery(this), jQuery(window).on("load resize orientationchange", e)
  });
  }
  blog_section();
  jQuery(window).on('load resize orientationchange', blog_section);  

  /* Blog Filter */
  jQuery(document).mouseup(function (e) {
    var footer = jQuery('.blog-filter');
    if (!footer.is(e.target) && footer.has(e.target).length === 0) 
    {
      jQuery(".blog-tag-filter").removeClass("active");
    }
  });

  /* Scroll Button */
  jQuery(document).on('click', '.scroll-btn, .article-share, .sort-desc-link', function(event) {
    var jQueryanchor = jQuery(this);
    jQuery('html, body').stop().animate({
      scrollTop: jQuery(jQueryanchor.attr('href')).offset().top
    }, 1500, 'easeInOutExpo');
    event.preventDefault();
  });
  }
  
  /* Brand Filter */
  var triggers = jQuery('.brand-filter a');
  var filters = jQuery('.brand-list .brand-item .brand-title');

  triggers.click(function() {
    jQuery(".all-link").removeClass('active');
    var takeLetter = jQuery(this).text(), result = 0;   
    filters.parent().hide();    
    triggers.removeClass('active');    
    jQuery(this).addClass('active');    
    jQuery('#result').show();    
    filters.each(function(i) {
      if ( RegExp('^'+takeLetter).test($(this).text()) ) {
        result += 1;
        jQuery(this).parent().fadeIn(222);        
      } 
    });
    jQuery('#result').html('<p>'+(result<1 ? 'Brands not avaliable.' : result+' Brands avaliable')+'</p>');
    //if (result<1) {alert('There is no result.');}
  });

  jQuery(".brand-filter .all-link").click(function(){
    jQuery(this).addClass('active');
    filters.parent().show();
    triggers.removeClass('active');
    jQuery('#result').hide();
  });
 
  /* Cart */
  jQuery('.cart-promo label').click(function(){
    jQuery(".cart-promo .promo-toggle").toggleClass('active');
  });

  if(jQuery("#mobileNavBar").hasClass("no-announcement")){
    jQuery("body").addClass("announcement-not");
  }

  /* Bottom Top */
  if (jQuery('#back-to-top').length) {
      var scrollTrigger = 100, // px
          backToTop = function () {
              var scrollTop = $(window).scrollTop();
              if (scrollTop > scrollTrigger) {
                  jQuery('#back-to-top').addClass('show');
              } else {
                  jQuery('#back-to-top').removeClass('show');
              }
          };
      backToTop();
      jQuery(window).on('scroll', function () {
          backToTop();
      });
      jQuery('#back-to-top').on('click', function (e) {
          e.preventDefault();
          jQuery('html,body').animate({
              scrollTop: 0
          }, 700);
      });
  }

  
  const quantityInput = document.querySelector('.template-product .js--num');
  const addButton = document.querySelector('.template-product .js--add');
  const minusButton = document.querySelector('.template-product .js--minus');

  // Add event listener for the plus button
  if(addButton){  
    addButton.addEventListener('click', function() {
        let currentQty = parseInt(quantityInput.value);
        quantityInput.value = currentQty + 1;
    });
  }

  // Add event listener for the minus button
  if(minusButton){  
    minusButton.addEventListener('click', function() {
        let currentQty = parseInt(quantityInput.value);
        if (currentQty > 1) { // Ensure the quantity doesn't drop below 1
            quantityInput.value = currentQty - 1;
        }
    });
  }

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
      return qty;
    } else {
      // Not a number. Default to 1.
      return 1;
    }
  };  

  Shopify.changeItem = function(line, quantity, callback) {
    var params = {
      type: 'POST',
      url: '/cart/change.js',
      data:  'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      success: function(cart) {
        if ((typeof callback) === 'function') {
          callback(cart);
        }
        else {
          Shopify.onCartUpdate(cart);
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        Shopify.onError(XMLHttpRequest, textStatus);
      }
    };
    jQuery.ajax(params);
  };  

  Shopify.onCartUpdate = function(cart) {
    // alert('There are now ' + cart.item_count + ' items in the cart.');
    if (document.body.classList.contains('template-cart')) {
      window.location.reload();
    }
  };  

  function updateQuantity(line, qty) {
    isUpdating = true;

    // Add activity classes when changing cart quantities
    var row = $('.cart-row[data-line="' + line + '"]').addClass('ajaxifyCart--is-loading');
    
    if ( qty === 0 ) {
      row.addClass('is-removed');
    }

    // Slight delay to make sure removed animation is done
    setTimeout(function() {
      Shopify.changeItem(line, qty);
    }, 250);
  }
    
  $('.template-cart .js--qty-adjuster').on('click', function() {
      var qtyMin = 0;
      var el = $(this),
          id = el.data('id'),
          qtySelector = el.siblings('.js--num'),
          qty = parseInt( qtySelector.val() ),
          line = parseInt($(this).closest('.cart-row').data('line'));

      var qty = validateQty(qty);
      qtyMin = $('body').hasClass('template-product') ? 1 : qtyMin;

      // Add or subtract from the current quantity
      if (el.hasClass('js--add')) {
        qty = qty + 1;
      } else {
        qty = qty <= qtyMin ? qtyMin : qty - 1;
      }

      console.log('Updated');
      // Update the input's number
      qtySelector.val(qty);
      updateQuantity(line, qty);
  });  
    
});